// @flow
import CalendarContainer from './CalendarContainer';

export default CalendarContainer;
